export const generateAprovalCode = () => {
  const uuid = crypto.randomUUID();
  const fourDigitSegment = 'AP' + uuid.replace(/[^0-9]/g, '').slice(0, 4);
  return fourDigitSegment;
};
